import { Component, OnInit } from '@angular/core';
import { AuthService } from './pages/auth/abstraction/auth.service';
import { Crisp } from 'crisp-sdk-web';
import { SeoService } from './pages/auth/services/seo.service';
import { USER_TYPE } from './pages/auth/models/User';
import { environment } from 'src/environments/environment';
import * as Sentry from '@sentry/angular-ivy';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { EXCHANGE_COUNTRY, exchangeToExchangeCountry } from './pages/auth/models/Onboarding';
import { TranslateService } from '@ngx-translate/core';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit {
  info;
  title = 'dollar-orderbook';
  showWhatsapp = false;

  constructor(
    public auth: AuthService,
    private seoService: SeoService,
    private route: ActivatedRoute,
    private translate: TranslateService,
    private router: Router,
  ) {}

  ngOnInit(): void {
    Crisp.configure('636454d4-fa7f-494b-a0e0-15c0485b74bc');
    this.translate.setDefaultLang('es');
    this.translate.use('es');
    this.route.queryParams.subscribe((params) => {
      if (params) {
        let exchangeCountry = params['country'] ? params['country'].toUpperCase() : null;
        if (this.auth.onboardingState.value?.exchangeCountry)
          exchangeCountry = this.auth.onboardingState.value.exchangeCountry;
        let segment: string;
        if (exchangeCountry === EXCHANGE_COUNTRY.CHL) {
          segment = 'wld_chl';
          this.translate.use('es');
        } else if (exchangeCountry === EXCHANGE_COUNTRY.COL) {
          segment = 'wld_col';
          this.translate.use('es');
        } else if (exchangeCountry === EXCHANGE_COUNTRY.BRA) {
          segment = 'wld_bra';
          this.translate.use('pt');
        } else if (exchangeCountry === EXCHANGE_COUNTRY.GTM) {
          segment = 'wld_gtm';
          this.translate.use('es');
        } else if (exchangeCountry === EXCHANGE_COUNTRY.CRI) {
          segment = 'wld_cri';
          this.translate.use('es');
        } else if (exchangeCountry === EXCHANGE_COUNTRY.PAN) {
          segment = 'wld_pan';
          this.translate.use('es');
        } else if (exchangeCountry === EXCHANGE_COUNTRY.MEX) {
          segment = 'wld_mex';
          this.translate.use('es');
        } else if (exchangeCountry === EXCHANGE_COUNTRY.PHL) {
          segment = 'wld_phl';
          this.translate.use('tag');
        } else if (this.auth.loggedUser?.type === USER_TYPE.TIENDACRYPTO) {
          segment = 'TC';
        } else if (exchangeCountry === EXCHANGE_COUNTRY.ARG) {
          segment = 'wld_arg';
          this.translate.use('es');
        }
        if (segment) {
          Crisp.session.setSegments([segment], true);
        }
      }
    });
    this.auth.loggedUserObs.subscribe((user) => {
      if (!user) return;
      Crisp.user.setNickname(user?.name || '');
      Crisp.user.setEmail(user?.email || '');
      Crisp.user.setPhone(user?.phoneNumber || '');
      Crisp.session.setData({
        cuit: user?.cuit || '',
        platform: 'TiendaCrypto',
        userId: user?._id || '',
        numberId: user?.numberId || '',
        AccumulatorWallet:
          '_' +
          (user?.exchangeCountry !== EXCHANGE_COUNTRY.ARG
            ? environment.accumulatorWalletOtherCountries
            : user
            ? environment.accumulatorWalletOP
            : ''),
        whitelabelAddress: user?.whitelabelAddress ? '_' + user?.whitelabelAddress : '',
        worldcoin: user?.type === USER_TYPE.WHITELABEL ? 'Si' : 'No',
        arsInBalance:
          user?.type === USER_TYPE.WHITELABEL && user?.balance?.fiat?.ARS > 100 ? true : false,
      });
      if (user) {
        Sentry.setUser({
          cuit: user?.cuit,
          whitelabelAddress: user?.whitelabelAddress,
        });
        if (user.exchangeCountry === EXCHANGE_COUNTRY.BRA) {
          this.translate.use('pt');
        } else if (user.exchangeCountry === EXCHANGE_COUNTRY.PHL) {
          this.translate.use('tag');
        } else {
          this.translate.use('es');
        }
      }
    });

    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        const path = event.urlAfterRedirects;
        this.setLanguageBasedOnPath(path);
      });

    this.auth.widgetUserObs.subscribe((user) => {
      if (!user) return;
      const country = exchangeToExchangeCountry[user.exchange];
      if (country === EXCHANGE_COUNTRY.BRA) {
        this.translate.use('pt');
      } else if (country === EXCHANGE_COUNTRY.PHL) {
        this.translate.use('tag');
      } else {
        this.translate.use('es');
      }
    });

    Crisp.chat.onChatOpened(() => {
      this.showWhatsapp = false;
    });

    Crisp.chat.onChatClosed(() => {
      this.showWhatsapp = false;
    });

    Crisp.setSafeMode(true);

    this.seoService.createCanonicalUrl();
  }

  private setLanguageBasedOnPath(path: string) {
    if (path.includes('support/bra') || path.includes('BRL')) {
      this.translate.use('pt');
    } else if (path.includes('support/phl') || path.includes('PHL')) {
      this.translate.use('tag');
    } else if (
      path.includes('support/col') ||
      path.includes('support/arg') ||
      path.includes('support/chl') ||
      path.includes('support/cri') ||
      path.includes('support/gtm') ||
      path.includes('support/mex') ||
      path.includes('support/pan')
    ) {
      this.translate.use('es');
    }
  }
}
